/* eslint-disable react-hooks/exhaustive-deps, jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  CardContent,
  useMediaQuery,
  ListItem,
  ListItemText,
  List,
  Button,
  Skeleton,
} from "@mui/material";
import moment from "moment";
import Image from "../Image"; // Update with the actual import path of your Image component
import { useTheme } from "../../style/theme";
import CheckIcon from "@mui/icons-material/Check";
import { useUser } from "../../hooks/Authorize";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Cancel = () => {
  const navigate = useNavigate();
  const platformUser = useUser();
  const isMobile = useMediaQuery("(max-width:600px)");

  const { mode } = useTheme();
  const [loading, setLoading] = useState(true); // New loading state
  const [subscriptions, setSubscriptionsData] = useState([]);

  const getSubscriptions = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `/store/subscription/cancel?userId=${platformUser?._id}`
      );
      const subscriptionsData = response?.data?.subscriptionHistory;

      // Filter out deleted subscriptions
      const activeSubscriptions = subscriptionsData?.filter(
        (sub) => !sub.isDelete
      );

      setSubscriptionsData(activeSubscriptions);
      console.log("subscriptionsData", activeSubscriptions);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch subscriptions:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const removeSubscription = async (id) => {
    try {
      const response = await axios.get(
        `/store/subscription/remove?planId=${id}`
      );
      const removeSubscription = response?.data?.subscriptionHistory;
      getSubscriptions();
      console.log("subscriptionsData", removeSubscription);
    } catch (error) {
      console.error("Failed to fetch organizations:", error);
    } finally {
      setLoading(false);
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getSubscriptions();
  }, []);
  const getImagePath = (s) => {
    const type = s.type?.toLowerCase();
    const name = s.name?.toLowerCase() || s.orgName?.toLowerCase();

    if (name?.includes("file") || type === "file" || type === "files")
      return "files/logo/2025/clikkle%20files.png";
    if (name?.includes("esign") || name?.includes("e-sign") || type === "esign")
      return "e-sign/logo/2025/clikkle%20esign.png";
    if (name?.includes("project") || type === "project" || type === "projects")
      return "projects/logo/2025/clikkle%20projects.png";
    if (name?.includes("chat") || type === "chat")
      return "chat/logo/2025/clikkle%20chat.png";
    if (name?.includes("campaign") || type === "campaigns")
      return "campaigns/logo/2025/clikkle%20campaigns.png";
    if (name?.includes("app") || name?.includes("worksuite") || type === "app" || type === "worksuite")
      return "worksuite/2025/clikkle%20worksuite.png";
    // if (name?.includes("ads") || type === "ads")
    //   return "ads/logo/2023/ads.png";
    // if (name?.includes("crm") || type === "crm")
    //   return "crm/2025/clikkle%20crm.png";
    // if (name?.includes("host") || type === "host")
    //   return "host/logo/2023/host.png";
    // if (name?.includes("launch") || type === "launch")
    //   return "launch/logo/2023/launch.png";
    // if (name?.includes("mail") || type === "mail")
    //   return "cmail/logo/2023/cmail.png";
    // if (name?.includes("pitch") || type === "pitch")
    //   return "pitch/logo/2023/pitch.png";
    if (name?.includes("hr") || type === "hr")
      return "hr/logo/2025/clikkle%20hr.png";

    return s.logo || "hr/logo/2025/clikkle%20hr.png";
  };

  const getDisplayTitle = (s) => {
    const type = s.type?.toLowerCase();
    const name = s.name?.toLowerCase() || s.orgName?.toLowerCase();

    if (name?.includes("file") || type === "file" || type === "files") return "Clikkle Files";
    if (name?.includes("esign") || name?.includes("e-sign") || type === "esign")
      return "Clikkle E-Sign";
    if (name?.includes("project") || type === "project" || type === "projects")
      return "Clikkle Projects";
    if (name?.includes("chat") || type === "chat") return "Clikkle Chat";
    if (name?.includes("campaign") || type === "campaigns")
      return "Clikkle Campaigns";
    if (name?.includes("app") || name?.includes("worksuite") || type === "app" || type === "worksuite")
      return "Clikkle Worksuite";
    // if (name?.includes("ads") || type === "ads") return "Clikkle Ads";
    // if (name?.includes("crm") || type === "crm") return "Clikkle CRM";
    // if (name?.includes("host") || type === "host") return "Clikkle Host";
    // if (name?.includes("launch") || type === "launch") return "Clikkle Launch";
    // if (name?.includes("mail") || type === "mail") return "Clikkle Mail";
    // if (name?.includes("pitch") || type === "pitch") return "Clikkle Pitch";
    if (name?.includes("hr") || type === "hr") return "Clikkle HR";

    return s.title || "Clikkle HR";
  };

  return (
    <Box
      sx={{
        paddingBottom: { xs: "60px", sm: "20px" },
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          },
          gap: 2,
          mt: 2,
          mx: 3,
        }}
      >
        {loading ? (
          <>
            <Box sx={{ gridColumn: "1 / -1", mb: 2, textAlign: "center" }}>
              <Typography variant="h6" color="textSecondary">
                Loading Cancelled Subscriptions...
              </Typography>
            </Box>
            {Array.from({ length: 9 }).map((_, index) => (
              <Box
                key={index}
                sx={{
                  borderRadius: "12px",
                  p: 2,
                  backgroundColor: mode === "light" ? "#fff" : "#141414",
                  border: `1px solid ${mode === "light" ? "#e5e7eb" : "#2E2E2E"
                    }`,
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Skeleton
                    variant="rectangular"
                    width={isMobile ? 50 : 80}
                    height={isMobile ? 50 : 80}
                    sx={{ borderRadius: 2, mr: 2 }}
                    animation="pulse"
                  />
                  <Box sx={{ flexGrow: 1 }}>
                    <Skeleton
                      variant="text"
                      width="70%"
                      height={30}
                      animation="pulse"
                    />
                    <Skeleton
                      variant="text"
                      width="50%"
                      height={20}
                      animation="pulse"
                    />
                  </Box>
                </Box>
                <Box sx={{ mt: 2 }}>
                  <Skeleton
                    variant="rectangular"
                    height={10}
                    width="100%"
                    sx={{ borderRadius: 1 }}
                    animation="pulse"
                  />
                  <Skeleton
                    variant="text"
                    width="30%"
                    height={15}
                    sx={{ mt: 1 }}
                    animation="pulse"
                  />
                </Box>
              </Box>
            ))}
          </>
        ) : subscriptions?.length > 0 ? (
          subscriptions?.map((service, index) => (
            <Box
              key={index}
              sx={{
                backgroundColor: mode === "light" ? "#fff" : "#141414",
                border: `1px solid ${mode === "light" ? "#e5e7eb" : "#2E2E2E"}`,
                borderRadius: "12px",
                width: "100%",
                px: { xs: 2, sm: 2 },
                pt: { xs: 2, sm: 3 },
                pb: 2,
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              <CardContent sx={{ p: 0 }}>
                {/* Image + Title Row */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: { xs: 2, sm: 3 },
                    mb: { xs: 1.5, sm: 2 },
                  }}
                >
                  {/* Icon Container */}
                  <Box
                    sx={{
                      width: { xs: 50, sm: 80 },
                      height: { xs: 50, sm: 80 },
                      borderRadius: "10px",
                      border: `1px solid ${mode === "light" ? "#d1d5db" : "#2E2E2E"
                        }`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Image
                      cdn={getImagePath(service)}
                      alt={`${getDisplayTitle(service)} Icon`}
                      style={{
                        width: "80%",
                        height: "80%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>

                  {/* Title and Price */}
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        fontSize: { xs: "1rem", sm: "1.3rem" },
                        color: mode === "light" ? "#000" : "#fff",
                      }}
                    >
                      {getDisplayTitle(service)}
                    </Typography>

                    {!["file", "files", "esign"].includes(String(service?.type || "").toLowerCase()) && (
                      <Typography
                        sx={{
                          fontWeight: "medium",
                          fontSize: { xs: "0.8rem", sm: "0.9rem" },
                          color: mode === "light" ? "#4b5563" : "#9ca3af",
                          mt: 0
                        }}
                      >
                        <span style={{ fontWeight: "normal" }}>Organization: </span>
                        {service?.orgName || service?.name || "Cant Find the Name"}
                      </Typography>
                    )}

                   {!["file", "files", "esign"].includes(String(service?.type || "").toLowerCase()) && ( <Typography
                      sx={{
                        color: "#A5A5A5",
                        fontSize: { xs: "0.75rem", sm: "0.875rem" },
                        display: "flex",
                        alignItems: "center",
                        gap: 0,
                        mt: 0
                      }}
                    >
                      {service.totalEmployees ?? 0}
                      {service.type === "file" || service.type === "files" ? " Files" : " Users"}
                    </Typography>
                    )}

                    <Typography
                      sx={{
                        color: "#A5A5A5",
                        fontSize: { xs: "0.8rem", sm: "1rem" },
                        mt: 0
                      }}
                    >
                      $
                      {(service?.plan?.amount || 0).toFixed(2) +
                        "/" +
                        (service?.plan?.interval || "month")}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#A5A5A5",
                        fontSize: { xs: "0.75rem", sm: "0.8rem" },
                      }}
                    >
                      Cancelled on:{" "}
                      {moment(service?.cancelDate).format("MMMM D, YYYY")}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#A5A5A5",
                        fontSize: { xs: "0.75rem", sm: "0.8rem" },
                      }}
                    >
                      Plan: {service?.plan?.name || service?.planName || "Cant Find the Plan Name"}
                    </Typography>
                    {/* <Typography
                    sx={{
                      color: "#A5A5A5",
                      fontSize: { xs: "0.75rem", sm: "0.8rem" },
                    }}
                  >
                    Organization: {service?.name}
                  </Typography> */}
                  </Box>
                </Box>

                {/* Features */}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    mt: { xs: 2, sm: 4 },
                    fontSize: { xs: "0.9rem", sm: "1.1rem" },
                  }}
                >
                  Your plan includes:
                </Typography>
                <List sx={{ pl: 0 }}>
                  {service?.plan?.permission
                    ?.filter((item) => item.isPermission)
                    ?.map((feature, i) => (
                      <ListItem key={i} sx={{ py: 0.5, px: 0 }}>
                        <ListItemText
                          primary={
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                fontSize: "12px",
                              }}
                            >
                              <CheckIcon size={14} /> {feature?.content}
                            </span>
                          }
                          primaryTypographyProps={{
                            fontSize: { xs: "0.75rem", sm: "0.9rem" },
                            color: "#A5A5A5",
                          }}
                        />
                      </ListItem>
                    ))}
                </List>
              </CardContent>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: 2,
                  mt: 2,
                  flexWrap: "wrap", // In case buttons don't fit in one line
                }}
              >
                <Button
                  variant="outlined"
                  size={isMobile ? "small" : "medium"}
                  sx={{
                    color: "#FF5353",
                    borderColor: "#FF5353",
                    fontSize: isMobile ? "1rem" : "1rem",
                    minWidth: isMobile ? "100px" : "auto",
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "rgba(255, 0, 0, 0.1)",
                    },
                    padding: "8px 25px",
                  }}
                  onClick={() => {
                    removeSubscription(service?._id);
                  }}
                >
                  Remove
                </Button>
                <Button
                  variant="contained"
                  size={isMobile ? "small" : "medium"}
                  sx={{
                    backgroundColor: "#3767B1",
                    color: "white",
                    fontSize: isMobile ? "1rem" : "1rem",
                    minWidth: isMobile ? "100px" : "auto",
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "#1E40AF",
                    },
                    padding: "8px 25px",
                    fontWeight: 500,
                  }}
                  onClick={() => {
                    service?.orgId
                      ? navigate(`/subscription/hr/purchase/${service?.orgId}`)
                      : service.type === "esign"
                        ? navigate("/subscription/esign/purchase")
                        : service.type === "projects"
                          ? navigate("/subscription/projects/purchase")
                          : navigate("/subscription/files/purchase");
                  }}
                >
                  Resubscribe
                </Button>
              </Box>
            </Box>
          ))
        ) : (
          <>
            <Box
              width="100%"
              display="flex"
              justifyContent="center"
              flexDirection="column"
              alignItems="center"
              height="300px"
              gridColumn="1 / -1"
              textAlign="center"
              sx={{ color: "#888" }}
            >
              <Typography variant="h6">
                No Cancelled Subscription Found
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Cancel;
